import { render } from "./DashboardSearch.vue?vue&type=template&id=2b8ed3c0"
import script from "./DashboardSearch.vue?vue&type=script&lang=js"
export * from "./DashboardSearch.vue?vue&type=script&lang=js"
script.render = render

export default script